import { render, staticRenderFns } from "./FailedSMSresend.vue?vue&type=template&id=99f26822&scoped=true"
import script from "./FailedSMSresend.vue?vue&type=script&lang=js"
export * from "./FailedSMSresend.vue?vue&type=script&lang=js"
import style0 from "./FailedSMSresend.vue?vue&type=style&index=0&id=99f26822&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f26822",
  null
  
)

export default component.exports